import { IResolveStepContext } from '../../../contexts/ResolveStep/ResolveStepContext';
import { IParticipantSectionsContext } from '../../../contexts/ParticipantSections/ParticipantSectionsContext';
import { IGeneralDataProviderProps } from '../../../contexts/GeneralDataProvider/generalDataProviderPropsMap';
import { IUserContext } from '../../../contexts/User/UserContext';
import { ILocationProps } from '../../../contexts/Location/locationProviderPropsMap';
import { ISettingsEventsContext } from '../../../contexts/SettingsEvents/SettingsEvents';

import { IChallengeSettings } from '../Settings/challengeSettings/challengeSettings.types';
import { UnpackSettingsValues } from '../../../types/helpers';
import { IInviteLinkProviderProps } from '../../../contexts/InviteLink/interfaces';
import { SelectedPaymentOption } from './components/Pricing/interfaces';
import { ParticipantStep } from '@wix/ambassador-challenges-v1-participant/types';
import { ILoadingContext } from '../../../contexts/Loading/interfaces';
import { IToastContext } from '../../../contexts/ToastContext/ToastContext';
import { IChallengeDataProps } from '../../../contexts/ChallengeDataProvider/helpers';
import { IMonitoringContext } from '../../../contexts/Monitoring/MonitoringContext';
import { ISocialGroupsProviderProps } from '../../../contexts/SocialGroups/interfaces';
import { IQuizContext } from '../../../contexts/Quiz/QuizContext';

export type IChallengePageSettingsValues =
  UnpackSettingsValues<IChallengeSettings> & {
    buttonState: 'default' | 'hover';
  };

export interface IChallengePageProps
  extends ILocationProps,
    IUserContext,
    ILoadingContext,
    IGeneralDataProviderProps,
    IChallengeDataProps,
    IParticipantSectionsContext,
    IResolveStepContext,
    IInviteLinkProviderProps,
    IToastContext,
    ISettingsEventsContext,
    IMonitoringContext,
    ISocialGroupsProviderProps,
    IQuizContext {
  settings: IChallengePageSettingsValues;
  eligiblePlans: any;
  userPaidPlans: any;
  isLoading: boolean;
  t(key: string, opts?: any): string;
  pageRef?: React.RefObject<HTMLElement>;
}

export enum IChallengeJoinRestriction {
  MAX_PARTICIPANTS = 'MAX_PARTICIPANTS',
  SPECIFIC_STARTED = 'SPECIFIC_STARTED',
  FINISHED = 'FINISHED',
  OFFLINE_PAYMENT_PENDING = 'OFFLINE_PAYMENT_PENDING',
}

export interface IChallengePageState {
  wixAdvertisementBannerHeight?: number;
  isEmptyStartDateError?: boolean;
  startDate?: string;
  selectedTabIndex?: number;
  currentStep?: ParticipantStep;
  isCurrentStateWasResolved?: boolean;
  isShareModalOpened?: boolean;
  isFeedbackModalOpened?: boolean;
  isLeaveModalOpened?: boolean;
  isCantJoinModalOpened?: boolean;
  selectedPaymentOption: SelectedPaymentOption | null;
  isChallengeDisabledForJoin?: boolean;
  challengeJoinRestrictions?: IChallengeJoinRestriction[];
  sharedCurrentDateForWeeksSelector?: Date;
  mobileScreen?: 'list' | 'view';
  stepViewAsPageId?: string;
  chosenSectionTileId?: string;
  sectionIdForceOpened?: string; // for ability to open certain section in list layout
  stepIdForceOpened?: string; // for ability to open certain step in list layout
  isParticipantCompletedChallengeState?: boolean;
  isDisableEligiblePlans?: boolean;
  savedQuestionnaireData?: any;
  isPremiumOutdatedModalOpened?: boolean;
}
